module.exports = __webpack_public_path__ + "static/media/PicsArt_03-12-07.55.47.b453aef8.jpg";